(function () {
  document.documentElement.classList.add('octobre-rose-page');

  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMq.matches) document.documentElement.classList.add('or-reduce');
  var INBOX_SEL =
    '#shopify-chat, #chat-button, shopify-chat, .shopify-chat, .shopify-inbox__chat-button, [id*="shopify-chat"], [class*="shopify-chat"], [data-inbox-chat], iframe[title*="Chat"], iframe[title*="chat"], iframe[title*="Assistance"], iframe[src*="inbox"], iframe[src*="chat"]';

  var hideInboxNode = function (el) {
    if (!el || el.nodeType !== 1) return;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('max-width', '0', 'important');
    el.style.setProperty('max-height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('left', '-9999px', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('z-index', '-1', 'important');
  };

  var hideInbox = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(INBOX_SEL);
    for (var i = 0; i < nodes.length; i++) hideInboxNode(nodes[i]);
    if (root && root.matches && root.matches(INBOX_SEL)) hideInboxNode(root);
  };

  hideInbox(document);
  if (window.MutationObserver) {
    var inboxObs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) hideInbox(added[j]);
      }
    });
    inboxObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (window.__orOctobreRoseUi) return;
  window.__orOctobreRoseUi = true;

  var STEP_NAMES = {
    1: '01 — Je regarde',
    2: '02 — Je palpe',
    3: "03 — Je ne m'arrête pas au sein",
    4: '04 — Je finis par le mamelon'
  };

  var progress = document.querySelector('[data-or-progress]');
  var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-or-step-btn]'));
  var nav = document.querySelector('.or-steps-nav');
  var lineFill = document.querySelector('[data-or-step-line]');
  var labelText = document.querySelector('[data-or-step-label-text]');
  var cards = Array.prototype.slice.call(document.querySelectorAll('.or-step[data-step]'));
  var activeN = 1;
  var labelTimer = null;
  var ticking = false;

  var setLabel = function (n) {
    if (!labelText) return;
    var next = STEP_NAMES[n] || '';
    if (labelText.textContent === next) return;
    if (reduceMq.matches) {
      labelText.textContent = next;
      labelText.classList.add('is-in');
      labelText.classList.remove('is-out');
      return;
    }
    window.clearTimeout(labelTimer);
    labelText.classList.remove('is-in');
    labelText.classList.add('is-out');
    labelTimer = window.setTimeout(function () {
      labelText.textContent = next;
      labelText.classList.remove('is-out');
      void labelText.offsetWidth;
      labelText.classList.add('is-in');
    }, 120);
  };

  var setActive = function (n) {
    if (!n) return;
    buttons.forEach(function (btn) {
      var val = Number(btn.getAttribute('data-or-step-btn'));
      btn.classList.toggle('is-active', val === n);
      btn.classList.toggle('is-done', val < n);
    });
    if (lineFill) lineFill.style.width = ((n - 1) / 3) * 100 + '%';
    if (n === activeN) return;
    activeN = n;
    setLabel(n);
  };

  setActive(1);

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var n = btn.getAttribute('data-or-step-btn');
      var el = document.getElementById('etape-' + n);
      if (!el) return;
      var navH = nav ? nav.getBoundingClientRect().height : 70;
      if (fcsmBar && fcsmBar.classList.contains('is-on')) {
        navH += fcsmBar.getBoundingClientRect().height;
      }
      var top = el.getBoundingClientRect().top + window.scrollY - navH - 8;
      window.scrollTo({ top: top, behavior: reduceMq.matches ? 'auto' : 'auto' });
    });
  });

  var updateProgress = function () {
    if (!progress) return;
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var p = max > 0 ? (h.scrollTop / max) * 100 : 0;
    progress.style.width = p + '%';
  };

  var updateIndicator = function () {
    if (!buttons.length || !cards.length) return;
    var vh = window.innerHeight || 1;
    var navH = nav ? nav.getBoundingClientRect().height : 72;
    var mobile = window.innerWidth < 900;
    var bestN = null;

    if (mobile) {
      var bestVis = -1;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var vis = Math.min(r.bottom, vh) - Math.max(r.top, navH);
        var n = Number(cards[i].getAttribute('data-step')) || i + 1;
        if (vis > bestVis) {
          bestVis = vis;
          bestN = n;
        }
      }
      if (bestVis <= 0) bestN = null;
    } else {
      var focusDesk = Math.max(80, vh * 0.4);
      var bestDist = Infinity;
      for (var j = 0; j < cards.length; j++) {
        var rd = cards[j].getBoundingClientRect();
        if (rd.bottom < 72 || rd.top > vh) continue;
        var nd = Number(cards[j].getAttribute('data-step')) || j + 1;
        var d = Math.abs(rd.top + rd.height / 2 - focusDesk);
        if (bestN == null || d < bestDist - 0.5 || (Math.abs(d - bestDist) <= 0.5 && nd < bestN)) {
          bestDist = d;
          bestN = nd;
        }
      }
    }

    if (bestN != null) setActive(bestN);
  };

  var heroFcsm = document.querySelector('[data-or-hero-fcsm]');
  var heroFcsmHold = document.querySelector('.or-hero__fcsm-hold');
  var heroTitle = document.querySelector('.or-hero__title');
  var sourcesEl = document.querySelector('.or-sources');
  var fcsmBar = document.querySelector('[data-or-fcsm-bar]');
  if (!fcsmBar && heroFcsm) {
    fcsmBar = document.createElement('div');
    fcsmBar.className = 'or-fcsm-bar';
    fcsmBar.setAttribute('data-or-fcsm-bar', '');
    fcsmBar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fcsmBar);
  }
  var fcsmHomeTop = null;
  var fcsmHomeH = null;
  var fcsmHomeW = null;
  var fcsmRange = null;
  var lerp = function (a, b, t) {
    return a + (b - a) * t;
  };
  var clamp01 = function (n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
  };
  var easeSticky = function (t) {
    return t * t * (3 - 2 * t);
  };
  var hideFcsmBar = function () {
    document.documentElement.classList.remove('or-fcsm-bar-on');
    if (!fcsmBar) return;
    fcsmBar.classList.remove('is-on');
    fcsmBar.style.opacity = '';
  };
  var clearHeroFcsm = function () {
    if (!heroFcsm) return;
    heroFcsm.classList.remove('is-sticky');
    heroFcsm.style.position = '';
    heroFcsm.style.left = '';
    heroFcsm.style.top = '';
    heroFcsm.style.height = '';
    heroFcsm.style.width = '';
    heroFcsm.style.transform = '';
    heroFcsm.style.zIndex = '';
    heroFcsm.style.pointerEvents = '';
    heroFcsm.style.opacity = '';
    heroFcsm.style.margin = '';
    hideFcsmBar();
  };
  var dropHeroFcsm = function () {
    if (!heroFcsm || !heroFcsmHold) return;
    if (heroFcsm.parentNode !== heroFcsmHold) heroFcsmHold.appendChild(heroFcsm);
    clearHeroFcsm();
  };
  var updateHeroFcsm = function () {
    if (!heroFcsm || !heroFcsmHold) return;
    var holdRect = heroFcsmHold.getBoundingClientRect();
    var mobile = window.innerWidth < 900;
    var barH = mobile ? 44 : 52;
    var destH = mobile ? 30 : 36;
    var destTop = Math.round((barH - destH) / 2);
    if (fcsmHomeH == null && holdRect.height) {
      fcsmHomeH = holdRect.height;
      fcsmHomeW = holdRect.width;
      fcsmHomeTop = holdRect.top;
      heroFcsmHold.style.width = fcsmHomeW + 'px';
      heroFcsmHold.style.height = fcsmHomeH + 'px';
      var titleTop = heroTitle ? heroTitle.getBoundingClientRect().top : holdRect.bottom + 80;
      fcsmRange = Math.max(90, Math.min(160, titleTop - destTop - destH - 16));
    }
    var vh = window.innerHeight || 1;
    var fromH = fcsmHomeH || holdRect.height || destH;
    var fromTop = fcsmHomeTop != null ? fcsmHomeTop : holdRect.top;
    var range = fcsmRange || Math.max(90, fromH * 1.6);
    var t = clamp01((fromTop - holdRect.top) / range);
    if (reduceMq.matches) t = holdRect.top < destTop + 8 ? 1 : 0;

    if (t <= 0.01) {
      dropHeroFcsm();
      return;
    }

    if (heroFcsm.parentNode !== document.body) document.body.appendChild(heroFcsm);
    heroFcsm.classList.add('is-sticky');
    var e = easeSticky(t);
    var top = lerp(fromTop, destTop, e);
    var h = lerp(fromH, destH, e);
    if (t >= 0.92) {
      top = destTop;
      h = destH;
    }

    var sourcesTop = sourcesEl ? sourcesEl.getBoundingClientRect().top : vh;
    var hide = sourcesTop < barH + 24;

    if (fcsmBar) {
      fcsmBar.classList.add('is-on');
      fcsmBar.style.opacity = hide ? '0' : String(e);
      document.documentElement.classList.toggle('or-fcsm-bar-on', !hide);
    }

    heroFcsm.style.left = '50%';
    heroFcsm.style.transform = 'translateX(-50%)';
    heroFcsm.style.top = top + 'px';
    heroFcsm.style.height = h + 'px';
    heroFcsm.style.width = 'auto';
    heroFcsm.style.zIndex = '100';
    heroFcsm.style.pointerEvents = 'none';
    heroFcsm.style.opacity = hide ? '0' : '1';
  };

  var onFrame = function () {
    ticking = false;
    updateProgress();
    updateIndicator();
    updateHeroFcsm();
  };

  var requestTick = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onFrame);
  };

  document.addEventListener('scroll', requestTick, { passive: true, capture: true });
  window.addEventListener('resize', function () {
    fcsmHomeH = null;
    fcsmHomeW = null;
    fcsmHomeTop = null;
    fcsmRange = null;
    if (heroFcsmHold) {
      heroFcsmHold.style.width = '';
      heroFcsmHold.style.height = '';
    }
    dropHeroFcsm();
    requestTick();
  });
  requestTick();

  if (window.IntersectionObserver && cards.length) {
    var revealIo = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-revealed');
          entry.target.classList.remove('or-step--await');
          revealIo.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.18
      }
    );

    cards.forEach(function (card) {
      if (reduceMq.matches) {
        card.classList.add('is-revealed');
        return;
      }
      if (window.innerWidth < 900) card.classList.add('or-step--await');
      revealIo.observe(card);
    });
  }

  var observeViewportReveal = function (selector, opts) {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!nodes.length) return;
    opts = opts || {};
    var staggerMs = opts.staggerMs == null ? 70 : opts.staggerMs;
    var desktop = window.innerWidth >= 900;

    if (reduceMq.matches || !window.IntersectionObserver) {
      nodes.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        var batch = [];
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          batch.push(entries[i].target);
          io.unobserve(entries[i].target);
        }
        if (!batch.length) return;
        batch.sort(function (a, b) {
          if (a === b) return 0;
          return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
        batch.forEach(function (el, idx) {
          var delay = desktop && batch.length > 1 ? idx * staggerMs : 0;
          if (delay) {
            window.setTimeout(function () {
              el.classList.add('is-in');
            }, delay);
          } else {
            el.classList.add('is-in');
          }
        });
      },
      {
        root: null,
        rootMargin: opts.rootMargin || '0px 0px -10% 0px',
        threshold: opts.threshold == null ? 0.2 : opts.threshold
      }
    );

    nodes.forEach(function (el) {
      el.classList.add('or-reveal');
    });
    void document.documentElement.offsetHeight;
    nodes.forEach(function (el) {
      io.observe(el);
    });
  };

  observeViewportReveal('.or-stat__big', {
    staggerMs: 70,
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.35
  });

  observeViewportReveal('.or-signes .or-card', {
    staggerMs: 70,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.16
  });

  var SHARE_TITLE = 'Octobre Rose × FCSM';
  var SHARE_TEXT = 'Autopalpation, réflexes, dépistage.';
  var SHARE_STRIP_PARAMS = [
    'preview_theme_id',
    'pb',
    'key',
    '_ab',
    '_fd',
    '_sc',
    '_bt',
    'preview',
    'ots',
    'organic_source',
    'organic_source_id'
  ];
  var sharePanel = null;
  var shareCopyTimer = null;
  var ensureSharePanel = function () {
    if (sharePanel && document.body.contains(sharePanel)) return sharePanel;
    sharePanel = document.querySelector('[data-or-share-panel]');
    if (sharePanel && sharePanel.parentNode !== document.body) {
      document.body.appendChild(sharePanel);
    }
    return sharePanel;
  };
  var cleanShareUrl = function (raw) {
    try {
      var u = new URL(raw, window.location.origin);
      SHARE_STRIP_PARAMS.forEach(function (p) {
        u.searchParams.delete(p);
      });
      u.hash = '';
      return u.origin + u.pathname;
    } catch (e) {
      return window.location.origin + window.location.pathname;
    }
  };
  var getShareUrl = function () {
    var panel = ensureSharePanel();
    var fromPanel = panel && panel.getAttribute('data-or-share-url');
    var canon = document.querySelector('link[rel="canonical"]');
    var raw =
      (fromPanel && fromPanel.trim()) ||
      (canon && canon.href) ||
      window.location.origin + window.location.pathname;
    return cleanShareUrl(raw);
  };
  var fillShareLinks = function (url) {
    var panel = ensureSharePanel();
    if (!panel) return;
    var wa = panel.querySelector('[data-or-share-wa]');
    var fb = panel.querySelector('[data-or-share-fb]');
    var mail = panel.querySelector('[data-or-share-mail]');
    var msg = SHARE_TEXT + ' ' + url;
    if (wa) wa.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(msg);
    if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    if (mail) {
      mail.href =
        'mailto:?subject=' +
        encodeURIComponent(SHARE_TITLE) +
        '&body=' +
        encodeURIComponent(SHARE_TEXT + '\n\n' + url);
    }
  };
  var closeSharePanel = function () {
    var panel = ensureSharePanel();
    if (!panel) return;
    panel.setAttribute('hidden', '');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  var openSharePanel = function () {
    var panel = ensureSharePanel();
    if (!panel) return;
    fillShareLinks(getShareUrl());
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = panel.querySelector('.or-share-panel__close');
    if (closeBtn) closeBtn.focus();
  };
  var copyShareUrl = function (btn) {
    var url = getShareUrl();
    var label = btn.querySelector('[data-or-share-copy-label]') || btn;
    var reset = function () {
      label.textContent = 'Copier le lien';
    };
    var done = function () {
      label.textContent = 'Lien copié !';
      window.clearTimeout(shareCopyTimer);
      shareCopyTimer = window.setTimeout(reset, 2000);
    };
    var fallbackCopy = function () {
      var input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        window.prompt('Copier le lien', url);
      }
      document.body.removeChild(input);
    };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      var settled = false;
      navigator.clipboard.writeText(url).then(function () {
        settled = true;
        done();
      }).catch(function () {
        settled = true;
        fallbackCopy();
      });
      window.setTimeout(function () {
        if (!settled) fallbackCopy();
      }, 350);
      return;
    }
    fallbackCopy();
  };
  var shareData = function () {
    return { title: SHARE_TITLE, text: SHARE_TEXT, url: getShareUrl() };
  };
  var isMobileShareContext = function () {
    var ua = navigator.userAgent || '';
    if (/Android|iPhone|iPod|webOS|IEMobile|Opera Mini/i.test(ua)) return true;
    if (/iPad/i.test(ua)) return true;
    try {
      if (navigator.userAgentData && navigator.userAgentData.mobile) return true;
    } catch (e) {}
    if (navigator.maxTouchPoints > 1 && /Macintosh|Mac OS X/i.test(ua)) return true;
    return false;
  };
  var canUseNativeShare = function (data) {
    if (!window.isSecureContext) return false;
    if (typeof navigator.share !== 'function') return false;
    // Edge/Chrome desktop expose navigator.share, but the picker often
    // never appears (NotAllowedError, hanging Promise, or silent resolve).
    if (!isMobileShareContext()) return false;
    if (typeof navigator.canShare === 'function') {
      try {
        if (!navigator.canShare(data)) return false;
      } catch (e) {
        return false;
      }
    }
    return true;
  };
  var isShareAbort = function (err) {
    if (!err) return false;
    if (err.name === 'AbortError') return true;
    var msg = String(err.message || err);
    return /abort|cancel/i.test(msg);
  };

  document.addEventListener('click', function (event) {
    var closeEl = event.target.closest && event.target.closest('[data-or-share-close]');
    if (closeEl) {
      event.preventDefault();
      closeSharePanel();
      return;
    }
    var copyBtn = event.target.closest && event.target.closest('[data-or-share-copy]');
    if (copyBtn) {
      event.preventDefault();
      copyShareUrl(copyBtn);
      return;
    }
    var shareBtn = event.target.closest && event.target.closest('[data-or-share]');
    if (!shareBtn) return;
    event.preventDefault();
    var data = shareData();
    fillShareLinks(data.url);
    if (!canUseNativeShare(data)) {
      openSharePanel();
      return;
    }
    try {
      var result = navigator.share(data);
      if (!result || typeof result.then !== 'function') {
        openSharePanel();
        return;
      }
      result.catch(function (err) {
        if (isShareAbort(err)) return;
        openSharePanel();
      });
    } catch (err) {
      if (isShareAbort(err)) return;
      openSharePanel();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var panel = ensureSharePanel();
    if (!panel || panel.hasAttribute('hidden')) return;
    closeSharePanel();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSharePanel);
  } else {
    ensureSharePanel();
  }
})();
